//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import IncomingGoods from'./components/incomingGoods.vue'
export default {
  components:{
    IncomingGoods
  },
  data() {
    return {
      tableData:[],
      invSub:false,
      pageNo:1, 
      total:10,
      resData:'',
    }
  },
  mounted(){
    this.info()
  },
  methods:{
    info(){
      this.tableData = []
      this.$axios.post('/mtea/stock/accept/getList', {pageNo:this.pageNo,pageSize:10,sysShopId:this.$route.query.shopId}).then(res => {
        // let data = []
        for(let j = 0;j<res.records.length;j++){
          res.records[j].getTime = (new Date(res.records[j].endTime).getTime())
        }
        for (var i = 0; i < res.records.length-1; i++) {
          for (var j = 0; j < res.records.length - 1 - i; j++) {
              // 相邻元素两两对比，元素交换，大的元素交换到后面
              if (res.records[j].getTime < res.records[j + 1].getTime) {
                  var temp = res.records[j];
                  res.records[j] = res.records[j+1];
                  res.records[j+1] = temp;
              }
          }
        }
        this.tableData = res.records
        this.total = res.total
      })
    },
    headerStyle(){
      let style = {}
      style.color = '#000'
      style['font-weight'] = 600
      style['text-align'] = 'center'
      style['background-color'] = '#f1f1f1'
      return style
    },
    rowStyle(){
      let style = {}
      style['text-align'] = 'center'
      style['font-size'] = '12px'
      return style
    },
    handleClick(row){
      console.log(row)
      this.invSub = true
      this.compile=true
        row.itemList.forEach(e => {
        e.goodsExtra = JSON.parse(e.goodsExtra)
      });
      this.resData = row
    },
    invSubState(){
      this.invSub = false
    },
  }
}
